// extracted by mini-css-extract-plugin
export default {"socialShareBarWrapper":"nyzdD"};